import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { translate, t } from "react-multi-lang";
import {
    userRegisterStart,
    usernameValidationStart,
} from "../../store/actions/UserAction";
import { Form, Button, Container, Row, Col, Image, Card, InputGroup } from "react-bootstrap";
import Datetime from 'react-datetime';
import moment from "moment"
import "./Signup.css";
import "react-datetime/css/react-datetime.css";

const Signup = (props) => {

    const [showPassword, setShowPassword] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);
    const [signupInputData, setSignupInputData] = useState({});
    const [birthDate, setBirthDate] = useState(null);
    const nameRef = useRef(null);
    const currentYear = moment().year();
    const maxDate = moment().subtract(18, "years").endOf("year");
    const minDate = moment().subtract(100, "years").startOf("year");

    const isValidDate = (current) => {
        return current.isBetween(minDate, maxDate, "year", "[]");
    };

    useEffect(() => {
        nameRef.current.focus();
        const prevTitle = document.title;
        document.title = "Sign Up | Rebel";
        return () => {
            document.title = prevTitle;
        };
    }, []);

    const handleSignup = (event) => {
        event.preventDefault();
        props.dispatch(userRegisterStart(signupInputData));
    }


    const handleUsernameValidation = (event, username) => {
        setSignupInputData({
            ...signupInputData,
            username: username,
        });
        props.dispatch(usernameValidationStart({ username: username }));
    };

    const searchParams = new URLSearchParams(props.location?.search || window.location.search);
    const redirectParam = searchParams.get("redirect");
    const isEventContext = searchParams.get("context") === "event" || (redirectParam && redirectParam.includes("/checkout/"));

    return (
        <div className="signin-wrapper">
            <div className="signup-card">

                <div className="signin-left">

                    {/* Logo */}
                    <div className="logo-wrapper">
                        <a href="/">
                            <img
                                src="https://admin.rebeltv.me/rebel-homepage-assets/logo.png"
                                alt="logo"
                                className="signin-logo d-inline"
                            />
                        </a>
                    </div>

                    {/* Title */}
                    <h2 className="signin-title">SIGN UP</h2>

                    <p className="signin-subtitle">
                        {isEventContext
                            ? "You're almost there! Create your free Rebel account to securely purchase and manage your event tickets."
                            : "Create an account to get started with your journey."}
                    </p>


                    <form className="signup-form"
                        onSubmit={handleSignup}
                        id="form"
                        method="post"
                        name="form"
                        autoComplete="off">

                        {/* ROW 1 */}
                        <div className="form-row">

                            <input
                                type="text"
                                placeholder="Name"
                                className="input-field"
                                ref={nameRef}
                                required
                                value={signupInputData.name}
                                name="name"
                                autoComplete="off"
                                onChange={(event) =>
                                    setSignupInputData({
                                        ...signupInputData,
                                        name: event.currentTarget.value,
                                    })
                                }
                            />
                            {props.validation.isValid}
                            <input
                                type="text"
                                className="input-field"
                                placeholder="User Name"
                                required
                                autoComplete="off"
                                value={signupInputData.user_name}
                                name="username"
                                onKeyUp={(event) =>
                                    handleUsernameValidation(
                                        event,
                                        event.currentTarget.value
                                    )
                                }
                            />
                            {props.validation.isInValid ? (
                                <div className="form-invalid-feedback">
                                    {t("username_already_taken")}
                                </div>
                            ) : (
                                ""
                            )}
                            {props.validation.isValid ? (
                                <div className="form-valid-feedback">
                                    Looks good!
                                </div>
                            ) : (
                                ""
                            )}

                        </div>

                        <div className="form-row">

                            <input
                                type="email"
                                placeholder="Email"
                                className="input-field"
                                required
                                autoComplete="off"
                                value={signupInputData.email}
                                name="email"
                                onChange={(event) =>
                                    setSignupInputData({
                                        ...signupInputData,
                                        email: event.currentTarget.value,
                                    })
                                }
                            /></div>
                        {/* PASSWORD */}
                        <div className="password-wrapper form-row">

                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                className="input-field full-width"
                                required
                                autoComplete="new-password"
                                value={signupInputData.password}
                                name="password"
                                onChange={(event) =>
                                    setSignupInputData({
                                        ...signupInputData,
                                        password: event.currentTarget.value,
                                    })
                                }
                            />

                            <span
                                className="eye-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                <i className={
                                    showPassword
                                        ? "fa fa-eye-slash"
                                        : "fa fa-eye"
                                }></i>
                            </span>

                        </div>


                        {/* ROW 2 */}
                        <div className="form-row">

                            <Datetime
                                value={birthDate}
                                closeOnSelect={true} // ✅ Auto close after selection
                                onChange={(date) => {
                                    setBirthDate(date)
                                    setSignupInputData({
                                        ...signupInputData,
                                        birth_year: moment(date).year(),
                                    })
                                }}
                                dateFormat="YYYY"
                                timeFormat={false}
                                isValidDate={isValidDate}
                                viewMode="years"
                                inputProps={{
                                    placeholder: t("birth_year"),
                                    readOnly: true,
                                    className: "input-field input_birthdate"
                                }}
                            />

                        </div>

                        {/* TERMS */}
                        <div className="terms-wrapper">

                            {/* <input
                                type="checkbox"
                                checked={agreeTerms}
                                onChange={() => setAgreeTerms(!agreeTerms)}
                            /> */}

                            <span className="agree-text">
                                By signing up you agree to our
                                <a href="/terms" target="_blank"> Terms of Service </a>
                                and
                                <a href="/privacy" target="_blank"> Privacy Policy</a>
                            </span>

                        </div>


                        {/* BUTTON */}
                        <button
                            className="signin-btn"
                            type="submit"
                            onClick={handleSignup}
                            disabled={props.signup.buttonDisable}
                        >
                            {props.signup.loadingButtonContent !== null
                                ? props.signup.loadingButtonContent
                                : "Sign up"}
                        </button>


                        {/* LOGIN LINK */}
                        <p className="signup-text">
                            Already have an account?
                            <a href={`/signin${props.location?.search || window.location.search || ""}`}> Sign in</a>
                        </p>

                    </form>

                </div>

            </div>
        </div>
    );
}

const mapStateToPros = (state) => ({
    signup: state.users.registerInputData,
    validation: state.users.validationInputData
});

function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
    mapStateToPros,
    mapDispatchToProps
)(translate(Signup));